import _classCallCheck from "/home/gonzalo/wfdev/webfarming-app-client/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/home/gonzalo/wfdev/webfarming-app-client/node_modules/@babel/runtime/helpers/esm/createClass";
import ItemVisitor from './ItemVisitor';
import ArrayList from '../../../../java/util/ArrayList';
var ArrayListVisitor = /*#__PURE__*/function () {
  function ArrayListVisitor() {
    _classCallCheck(this, ArrayListVisitor);
    ArrayListVisitor.constructor_.apply(this, arguments);
  }
  _createClass(ArrayListVisitor, [{
    key: "visitItem",
    value: function visitItem(item) {
      this._items.add(item);
    }
  }, {
    key: "getItems",
    value: function getItems() {
      return this._items;
    }
  }, {
    key: "interfaces_",
    get: function get() {
      return [ItemVisitor];
    }
  }], [{
    key: "constructor_",
    value: function constructor_() {
      this._items = new ArrayList();
    }
  }]);
  return ArrayListVisitor;
}();
export { ArrayListVisitor as default };